import AxiosCustom from "../../../components/common/apiConfigWebsitPouyan/index";

export function select_content_getContentHtml_api(payload) {

  const config = {

    url: `/Content/GetContentHtml/${payload?.data?.param}`,
    method:'GET'
  };

  const data = payload?.data?.body

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
